function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { isRequestInFlight, NetworkStatus } from "@knocklabs/client";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { EmptyFeed } from "../EmptyFeed";
import { useKnockFeed } from "../KnockFeedProvider";
import { Spinner } from "../Spinner";
import { NotificationCell } from "../NotificationCell";
import { FilterStatus } from "../../constants";
import { NotificationFeedHeader } from "./NotificationFeedHeader";
import useOnBottomScroll from "../../hooks/useOnBottomScroll";
import useFeedSettings from "../../hooks/useFeedSettings";
import { useTranslations } from "../../hooks/useTranslations";

var defaultRenderItem = props => /*#__PURE__*/React.createElement(NotificationCell, _extends({
  key: props.item.id
}, props));

var defaultRenderHeader = props => /*#__PURE__*/React.createElement(NotificationFeedHeader, props);

var LoadingSpinner = _ref => {
  var {
    colorMode
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "rnf-notification-feed__spinner-container"
  }, /*#__PURE__*/React.createElement(Spinner, {
    thickness: 3,
    size: "16px",
    color: colorMode === "dark" ? "rgba(255, 255, 255, 0.65)" : undefined
  }));
};

var poweredByKnockUrl = "https://knock.app?utm_source=powered-by-knock&utm_medium=referral&utm_campaign=knock-branding-feed";
export var NotificationFeed = _ref2 => {
  var {
    EmptyComponent = /*#__PURE__*/React.createElement(EmptyFeed, null),
    renderItem = defaultRenderItem,
    onNotificationClick,
    onMarkAllAsReadClick,
    initialFilterStatus = FilterStatus.All,
    header,
    renderHeader = defaultRenderHeader
  } = _ref2;
  var [status, setStatus] = useState(initialFilterStatus);
  var {
    feedClient,
    useFeedStore,
    colorMode
  } = useKnockFeed();
  var {
    settings
  } = useFeedSettings(feedClient);
  var {
    t
  } = useTranslations();
  var {
    pageInfo,
    items,
    networkStatus
  } = useFeedStore();
  var containerRef = useRef(null);
  useEffect(() => {
    setStatus(initialFilterStatus);
  }, [initialFilterStatus]);
  useEffect(() => {
    // When the feed client changes, or the status changes issue a re-fetch
    feedClient.fetch({
      status
    });
  }, [feedClient, status]);
  var noItems = items.length === 0;
  var requestInFlight = isRequestInFlight(networkStatus); // Handle fetching more once we reach the bottom of the list

  var onBottomCallback = useCallback(() => {
    if (!requestInFlight && pageInfo.after) {
      feedClient.fetchNextPage();
    }
  }, [requestInFlight, pageInfo, feedClient]); // Once we scroll to the bottom of the view we want to automatically fetch
  // more items for the feed and bring them into the list

  useOnBottomScroll({
    ref: containerRef,
    callback: onBottomCallback,
    offset: 70
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "rnf-notification-feed rnf-notification-feed--".concat(colorMode)
  }, header || renderHeader({
    setFilterStatus: setStatus,
    filterStatus: status,
    onMarkAllAsReadClick
  }), /*#__PURE__*/React.createElement("div", {
    className: "rnf-notification-feed__container",
    ref: containerRef
  }, networkStatus === NetworkStatus.loading && /*#__PURE__*/React.createElement(LoadingSpinner, {
    colorMode: colorMode
  }), /*#__PURE__*/React.createElement("div", {
    className: "rnf-notification-feed__feed-items-container"
  }, networkStatus !== NetworkStatus.loading && items.map(item => renderItem({
    item,
    onItemClick: onNotificationClick
  }))), networkStatus === NetworkStatus.fetchMore && /*#__PURE__*/React.createElement(LoadingSpinner, {
    colorMode: colorMode
  }), !requestInFlight && noItems && EmptyComponent), (settings === null || settings === void 0 ? void 0 : settings.features.branding_required) && /*#__PURE__*/React.createElement("div", {
    className: "rnf-notification-feed__knock-branding"
  }, /*#__PURE__*/React.createElement("a", {
    href: poweredByKnockUrl,
    target: "_blank"
  }, t("poweredBy"))));
};
//# sourceMappingURL=NotificationFeed.js.map